import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AccountService } from './services/account.service';

@Injectable()
export class AuthGuardErrorService implements CanActivate {

  constructor(public accountService: AccountService,
              public router: Router) { }

  /**
   * To access this page, user mustn't have any roles except USER
   */
  canActivate(): boolean {
    if (this.accountService.isMaintainer()) {
      this.router.navigate(['dashboard']);
      return false;
    }

    return true;
  }


}



// WEBPACK FOOTER //
// ./src/app/auth-guard-error.service.ts